import { render, staticRenderFns } from "./CustomThresholds.vue?vue&type=template&id=60a0fb18&scoped=true&"
import script from "./CustomThresholds.vue?vue&type=script&lang=ts&"
export * from "./CustomThresholds.vue?vue&type=script&lang=ts&"
import style0 from "./CustomThresholds.vue?vue&type=style&index=0&id=60a0fb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0fb18",
  null
  
)

export default component.exports